export default defineAppConfig({
  title: "Jobmate",
  nuxtIcon: {},
  ui: {
    primary: "violet",
    gray: "cool",
    button: {
      size: { "2xl": "text-lg" },
      gap: { "2xl": "gap-x-2.5" },
      padding: {
        "2xl": "px-8 py-2.5",
      },
      square: {
        "2xl": "p-2.5",
      },
      font: "font-bold",
      default: {
        size: "2xl",
      },
    },
    table: {
      divide: "divide-gray-400",
      tbody: "divide-gray-400",
      th: {
        font: "font-normal text-sm",
        color: "text-gray-600",
      },
      td: {
        color: "text-gray-900 text-semibold text-lg",
      },
      tr: {
        active: "hover:bg-white",
      },
    },
    select: {
      default: {
        size: "xl",
      },
    },
    input: {
      default: {
        size: "xl",
      },
    },
    badge: {
      size: { "2xl": "text-base px-3 py-2" },
      default: {
        size: "2xl",
      },
    },
    avatar: {
      size: { "2xl": "w-[320px] h-[320px]" },
    },
    formGroup: {
      label: {
        base: "pb-4 text-xl font-bold text-gray-900",
      },
    },
  },
});
